import sharedLabel from '../../translation'
import {PaymentType} from '../../types/Bids'
import type {ILabel} from '../../../../types'

export default {
    paymentType(paymentType: PaymentType): ILabel {
        if(paymentType === PaymentType.cashOnDelivery) {
            return <ILabel>{
                de: 'Nachnahme',
                en: 'Cash on Delivery',
                es: 'Contra reembolso',
                fr: 'Contre remboursement',
                nl: 'Rembours',
                it: 'Contrassegno',
            }
        }
        if(paymentType === PaymentType.creditCard) {
            return <ILabel>{
                de: 'Kreditkarte',
                en: 'Credit Card',
                es: 'Tarjeta de crédito',
                fr: 'Carte de crédit',
                nl: 'Credit card',
                it: 'Carta di credito',
            }
        }
        if(paymentType === PaymentType.prePayment) {
            return <ILabel>{
                de: 'Vorkasse',
                en: 'Prepay',
                es: 'Transferencia bancaria',
                fr: 'Virement bancaire',
                nl: 'Bankoverschrijving',
                it: 'Carta prepagata',
            }
        }
        return <ILabel>{
            de: 'undefined',
            fr: 'undefined',
            it: 'undefined',
            es: 'undefined',
            nl: 'undefined',
            en: 'undefined',
        }
    },
    activationTitle: <ILabel>{
        de: 'Freischaltung Liveshows',
        en: 'Activation Live Shows',
        es: 'Registrarse para pujar online',
        fr: 'Inscription télé-achat',
        nl: 'Activeer de Juwelo Live',
        it: 'Attivazione Acquisto in Diretta',
    },
    telephone: <ILabel>{
        de: 'Telefon',
        en: 'Telephone',
        es: 'Teléfono',
        fr: 'Téléphone',
        nl: 'Telefoon',
        it: 'Telefono',
    },
    telephoneHint: <ILabel>{
        de: 'Die Teilnahme an unseren Live-Shows erfordert die Angabe Ihrer Telefonnumer.',
        en: 'Participation in our live shows requires the provision of your telephone number.',
        es: 'Se requiere del registro de su número de teléfono para la participación en la ofertas live.',
        fr: 'La participation à nos offres en direct nécessite la communication de votre numéro de téléphone.',
        nl: 'Deelname aan onze live shows vereist dat u uw telefoonnummer opgeeft.',
        it: 'La partecipazione alle nostre offerte in diretta richiede la comunicazione del tuo numero di telefono.',
    },
    paymentMethod: <ILabel>{
        de: 'Zahlungsart',
        en: 'Payment Method',
        es: 'Método de pago',
        fr: 'Mode de paiement',
        nl: 'Betalingsmethode',
        it: 'Metodo di pagamento',
    },
    paymentMethodHint: <ILabel>{
        de: 'Diese Zahlart gilt ausschließlich der Abwicklung Ihrer Gebote.',
        en: 'This payment method is exclusively for the processing of your bids.',
        es: 'Este método de pago es exclusivamente para la tramitación de puja.',
        fr: 'Ce mode de paiement est exclusivement réservé au traitement de vos offres.',
        nl: 'Deze betaalmethode is uitsluitend bedoeld om uw bod te verwerken.',
        it: 'Questo metodo di pagamento è riservato esclusivamente all\'elaborazione delle tue offerte.',
    },
    save: <ILabel>{
        de: 'Speichern',
        en: 'Save',
        es: 'Guardar',
        fr: 'Sauvegarder',
        nl: 'Opslaan',
        it: 'Salva',
    },
    phoneInvalidEmpty: <ILabel>{ // phone number is empty
        de: 'Bitte Telefonnummer angeben',
        en: 'Please enter phone number',
        es: 'Ingrese su número de teléfono por favor',
        fr: 'Veuillez entrer votre numéro de téléphone',
        nl: 'Voer uw telefoonnummer in',
        it: 'Si prega di inserire il numero di telefono',
    },
    phoneInvalidSyntax: <ILabel>{ // phone number does not have required syntax
        de: 'Ungültige Telefonnummer, bitte überprüfen',
        en: 'Invalid phone number, please check',
        es: 'Número de teléfono inválido, corríjalo por favor',
        fr: 'Numéro de téléphone invalide, veuillez le corriger',
        nl: 'Ongeldig telefoonnummer, gelieve te controleren',
        it: 'Numero di telefono non valido, si prega di controllare',
    },
    
    serverError: sharedLabel.serverError,
    
    // confirmation notification
    
    successNotificationTitle: <ILabel>{
        de: 'Bietdaten erfolgreich ergänzt',
        en: 'Bidding data successfully added',
        es: 'Datos de puja completados con éxito.',
        fr: 'Les données d\'enchères ont été complétées avec succès.',
        nl: 'Biedingsgegevens succesvol toegevoegd',
        it: 'Dati per l’asta in diretta completati con successo',
    },
    successNotificationMessage: <ILabel>{
        de: 'Ihre Bietdaten wurden übernommen. Sie können diese in ihrem Kundenkonto jederzeit einsehen und bearbeiten.',
        en: 'Your bidding data has been added. You can view and edit them in your customer account at any time.',
        es: 'Sus datos de puja están registrados. Usted puede hacer cambios a su cuenta de cliente cuando desee.',
        fr: 'Les détails de votre enchère sont enregistrés. Vous pouvez apporter des modifications à votre compte client à tout moment.',
        nl: 'Uw biedingsgegevens zijn toegevoegd. U kunt ze op elk moment bekijken en bewerken in uw klantenaccount.',
        it: 'I tuoi dati per l’asta in diretta sono stati trasferiti. Puoi visualizzarli e modificarli nel tuo account cliente in qualsiasi momento.',
    },
}